import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [logoUrl] = useState(`${process.env.PUBLIC_URL || ''}/logo_sirep.png`);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Afficher le message de succès si l'utilisateur vient de s'inscrire
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      // Nettoyer le state pour éviter de réafficher le message
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
    if (loginError) {
      setLoginError('');
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = 'Le nom d\'utilisateur est obligatoire';
    }

    if (!formData.password) {
      newErrors.password = 'Le mot de passe est obligatoire';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await login(formData.username, formData.password);
      if (result.success) {
        const roles = result.user?.roles || [];
        if (roles.includes('ROLE_RH') || roles.includes('ROLE_MANAGER')) {
          navigate('/');
        } else {
          navigate('/mon-espace');
        }
      } else {
        setLoginError(result.error || 'Erreur de connexion');
      }
    } catch (error) {
      setLoginError('Une erreur est survenue lors de la connexion');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          {logoUrl && (
            <span className="login-logo-wrap">
              <img src={logoUrl} alt="Logo" className="login-logo" />
            </span>
          )}
          <h2>Connexion</h2>
          <p>Module Ressources Humaines</p>
        </div>

        {successMessage && (
          <div className="success-banner">
            {successMessage}
          </div>
        )}

        {loginError && (
          <div className="error-banner">
            {loginError}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Nom d'utilisateur *</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className={errors.username ? 'error' : ''}
              placeholder="Entrez votre nom d'utilisateur"
              autoComplete="username"
            />
            {errors.username && <span className="error-message">{errors.username}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'error' : ''}
              placeholder="Entrez votre mot de passe"
              autoComplete="current-password"
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

                
      </div>
    </div>
  );
};

export default Login;

